import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__fb-monophonic",
  "use": "icon__fb-monophonic-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__fb-monophonic\"><title>Path</title><path d=\"M17.273 0H1.727C.773 0 0 .773 0 1.727v15.546C0 18.227.773 19 1.727 19h8.637v-7.773H7.773v-2.59h2.59V7.244c0-2.634 1.284-3.79 3.473-3.79 1.049 0 1.603.077 1.866.113v2.477h-1.493c-.93 0-1.254.491-1.254 1.484v1.107h2.723l-.37 2.591h-2.353V19h4.318c.954 0 1.727-.773 1.727-1.727V1.727C19 .773 18.226 0 17.273 0z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol